import axios from 'axios';

const ClientAPI = axios.create({
    baseURL: (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? 'http://localhost/' : 'https://www.gloowe.com',
    withCredentials: true,
});

export default ClientAPI;